import {
  type RestoreAccount,
  type InventoryResource,
  type Snapshot,
  Provider,
} from '@repo/api-gw-sdk';

import { useEnvironment } from '@/contexts/useEnvironment';

import { AzurePostgresConfiguration } from './steps/azurePostgresConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreAzurePostgresState {
  resourceId: string;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: RestoreAccount;
  resourceGroup?: string;
  location?: string;
  serverName?: string;
  keepOriginalTags: boolean;
  initialTags: Record<string, string>;
  tags: Record<string, string>;
}

const restoreAzurePostgresFlow: Step<RestoreAzurePostgresState> = {
  id: 'select_target_account_step',
  Component: SelectTargetAccountStep,
  next: [
    {
      id: 'azure_postgres_configuration',
      Component: AzurePostgresConfiguration,
    },
  ],
};

export const RestoreAzurePostgresWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  const { isDemo, isDev } = useEnvironment();

  return (
    <Wizard<RestoreAzurePostgresState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreAzurePostgresFlow]}
      initialState={{
        snapshot,
        resourceId: snapshot.resourceId,
        supportedCloudProviders:
          isDemo || isDev
            ? [Provider.Aws, Provider.Azure, Provider.Gcp]
            : [Provider.Azure],
        serverName: resource.resourceName.split('/')[0] ?? '',
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
        location: resource.region,
      }}
      title={'Restore PostgreSQL Server'}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
